function hexToRGB(h) {
  let r = 0, g = 0, b = 0;

  // 3 digits
  if (h.length == 4) {
    r = "0x" + h[1] + h[1];
    g = "0x" + h[2] + h[2];
    b = "0x" + h[3] + h[3];

  // 6 digits
  } else if (h.length == 7) {
    r = "0x" + h[1] + h[2];
    g = "0x" + h[3] + h[4];
    b = "0x" + h[5] + h[6];
  }

  let colobj = {rr: +r, gg: +g, bb: +b};
  return colobj;
}

// FUNCTION TO CONVERT RGB TO HEX
function RGBToHex(r,g,b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);

  if (r.length == 1)
    r = "0" + r;
  if (g.length == 1)
    g = "0" + g;
  if (b.length == 1)
    b = "0" + b;

  return "#" + r + g + b;
}

// FUNCTION TO AVERAGE TWO COLORS
export function colorAvg(hexa, hexb) {
  let rgbA = hexToRGB(hexa);
  let rgbB = hexToRGB(hexb);

  let r = parseInt( Math.sqrt((rgbA.rr ** 2 + rgbB.rr ** 2) / 2.0) );
  let g = parseInt( Math.sqrt((rgbA.gg ** 2 + rgbB.gg ** 2) / 2.0) );
  let b = parseInt( Math.sqrt((rgbA.bb ** 2 + rgbB.bb ** 2) / 2.0) );

  let hex = RGBToHex(r,g,b);

  return hex;
}

// FUNCTION TO CAPITALIZE A STRING
export function capitalize(s) {
  return s[0].toUpperCase() + s.substring(1);
}


// BLUR NODE ON ESCAPE
export function blurOnEscape(node) {

  const handleKey = event => {
    if (event.key === 'Escape' && node && typeof node.blur === 'function') {
      node.blur();
    }
  }

  node.addEventListener('keydown', handleKey);

  return {
    destroy() {
      node.removeEventListener('keydown', handleKey);
    }
  }
}
